import { clsx } from 'clsx'
import { Link, useLocation } from 'react-router-dom'

export default function NavItem({
	href,
	label,
	highlightMatch,
	className,
	activeClassName,
}: {
	href: string
	label: string
	highlightMatch: string
	className?: string
	activeClassName?: string
}) {
	const location = useLocation()

	const isActive = (regex: string) => {
		return location.pathname.startsWith(regex)
	}

	return (
		<Link
			to={href}
			className={clsx(className, { [activeClassName || '']: isActive(highlightMatch) })}
		>
			{label}
		</Link>
	)
}
